import { shouldFetchCarImage } from "../helperFunctions";

export default async function CarImageService(hostUrl: string, carRegistrationNumber: string, brand: string) {

    if (!hostUrl) {
        throw Error("Missing API host URL");
    }

    if (!shouldFetchCarImage(brand) || !carRegistrationNumber) {
        return {};
    }

    const response = await fetch(hostUrl + `/api/${brand}/volvo-car-image`, {
        method: "POST",
        body: JSON.stringify({
            "carRegistrationNumber": carRegistrationNumber
        }),
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
        },
    });
    if (!response.ok) {
        return {};
    }
    try {
        return await response.json();
    } catch {
        return {};
    }
}